"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationDataForPayout = void 0;
const class_transformer_1 = require("class-transformer");
const AssignationPayout_1 = require("../models/AssignationPayout");
const Compensation_1 = require("../models/Compensation");
const DriverDebt_1 = require("../models/DriverDebt");
const Payout_1 = require("../models/Payout");
const Penalty_1 = require("../models/Penalty");
const SimpleUser_1 = require("../models/SimpleUser");
const Subsidy_1 = require("../models/Subsidy");
const User_1 = require("../models/User");
const SimpleOrder_1 = require("./SimpleOrder");
class AssignationDataForPayout {
    assignationId;
    assignationStatus;
    vehicleTitle;
    vehicleId;
    acceptationNote;
    user;
    simpleOrder;
    paidCash;
    paidOnline;
    penalties;
    compensations;
    subsidies;
    sumOfPenalties;
    sumOfCompensations;
    sumOfSubsidies;
    assignationPayouts;
    payouts;
    driverDebts = [];
    debtsAuthorSimpleUsers;
    sumOfPayouts;
    sumOfDebts;
    amountForDriver;
    driversBalance;
    feeVatDeducted;
    amountToPayout;
}
exports.AssignationDataForPayout = AssignationDataForPayout;
__decorate([
    (0, class_transformer_1.Type)(() => User_1.User),
    __metadata("design:type", User_1.User)
], AssignationDataForPayout.prototype, "user", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SimpleOrder_1.SimpleOrder),
    __metadata("design:type", SimpleOrder_1.SimpleOrder)
], AssignationDataForPayout.prototype, "simpleOrder", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Penalty_1.Penalty),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "penalties", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Compensation_1.Compensation),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "compensations", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Subsidy_1.Subsidy),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "subsidies", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AssignationPayout_1.AssignationPayout),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "assignationPayouts", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Payout_1.Payout),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "payouts", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => DriverDebt_1.DriverDebt),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "driverDebts", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SimpleUser_1.SimpleUser),
    __metadata("design:type", Array)
], AssignationDataForPayout.prototype, "debtsAuthorSimpleUsers", void 0);
//# sourceMappingURL=AssignationDataForPayout.js.map